import {action, autorun, observable} from 'mobx';
import {customEvent} from "../utils/analyticsUtil";
import {events} from "../constants/enums";

const sendEvents = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';


class GoogleOptimizeStore {
    @observable experimentsList = [
        {name: 'PhoneTest', id: 'n_ApQOG8QN-ble0aQU5gOw', variant: null},
        {name: 'PromoTest', id: 's7F3YiZASmqJD7wahAnxlQ', variant: null},
        {name: 'OnboardingTest', id: '4Fayt5AWRi2lSMWMpqWFsw', variant: null},
        {name: 'OnboardingTest2', id: 'vyKFDOw9S_KbK-UK06T4Sg', variant: null}
    ];

    gtag() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
    };

    constructor() {
        if (sendEvents) {
            this.gtag('event', 'optimize.callback', {callback: this.prepareExperiment});
        } else {
            this.experimentsList.forEach(exp => {
                this.prepareExperiment(Math.random() > 0.5 ? '0' : '1', exp.id);
            });
        }
    }

    @action prepareExperiment = (variant, id) => {
        let exp = this.experimentsList.find(e => e.id === id);
        if (exp) {
            exp.variant = variant;
            customEvent(events.Experiment, {experimentName: exp.name, experimentId: exp.id, experimentVariant: exp.variant});
        } else {
            console.log('unknown experiment: ', id, ' variant: ', variant);
        }
    };


    async getVariantByName(testName) {
        let exp = this.experimentsList.find(e => e.name === testName);
        if (!exp) {
            console.log('unknown experiment name: ', testName);
            return null;
        }
        if (!exp.variant) {
            console.log('exp not ready yet: ' + testName);
            return new Promise((resolve, reject) => {
                this.listner = autorun(() => {
                    if (exp.variant) {
                        console.log('exp reday: ' + testName + ' variant: ' + exp.variant);
                        resolve(exp.variant);
                        this.listner();
                    }
                })
            })
        }
        return exp.variant;
    }

    async getPhoneVariant() {
        return this.getVariantByName('PhoneTest');
    }

    async getPromoTestVariant() {
        return this.getVariantByName('PromoTest');
    }

    async getOnboardingVariant() {
        return this.getVariantByName('OnboardingTest2');
    }
}

const googleOptimizeStore = new GoogleOptimizeStore();
export default googleOptimizeStore;
